// MembersPanel.jsx
import { useEffect, useState } from "react";
import MemberList from "./MemberList";
import MemberDetailsView from "./MembersDetailsView";
import { regionsData } from "../../../constants/regiones";
import { getAllCompanies } from "../../../services/companiesService";
import { PageLoader } from "../../loader";

export default function MembersPanel({ isSubmitting }) {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCompanies = async () => {
    try {
      setLoading(true);
      const response = await getAllCompanies();
      setCompanies(response);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCompanies();
  }, []);

    if (loading) return <PageLoader message="Cargando socios..." />;
  

  return (
    <div className="relative w-full h-screen overflow-x-hidden overflow-y-auto">
      {/* Tabla de socios */}
      <div
        className={`transition-transform duration-500 ease-in-out w-full ${
          selectedCompany ? "-translate-x-full" : "translate-x-0"
        }`}
      >
        <MemberList
          companies={companies}
          loading={loading}
          error={error}
          onSelectCompany={setSelectedCompany}
          reload={loadCompanies} // 👈 función para recargar la lista de socios
        />
      </div>

      {/* Vista de detalles */}
      <div
        className={`absolute inset-0 bg-white transition-transform duration-500 ease-in-out ${
          selectedCompany ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {selectedCompany && (
          <MemberDetailsView
            company={selectedCompany}
            onBack={() => setSelectedCompany(null)}
            onSave={() => {
              loadCompanies(); // 👈 recarga al guardar
              setSelectedCompany(null);
            }}
            regionsData={regionsData}
            isSubmitting={isSubmitting}
          />
        )}
      </div>
    </div>
  );
}
